import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-14 md:py-20 bg-navy text-white" data-id="element-245">
      <div className="container mx-auto px-4" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-247">
          <div className="flex items-center justify-center mb-8" data-id="element-248">
            <AlertTriangle size={48} className="text-gold" data-id="element-249" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-12 text-gold" data-id="element-250">
            EL PROBLEMA DEL QUE NADIE HABLA
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-251">
            <p data-id="element-252">
              Aquí está la verdad que las grandes compañías de seguros no
              quieren que sepas:
            </p>

            <p className="text-2xl font-bold text-white bg-white/10 p-6 rounded-lg border-l-4 border-gold" data-id="element-253">
              La mayoría de las personas están pagando por una cobertura que no
              entienden completamente.
            </p>

            <p data-id="element-254">
              Obtuvieron una cotización en línea. Hicieron clic en aceptar.
              Recibieron una tarjeta por correo. Y asumieron que estaban
              protegidos.
            </p>

            <p className="font-bold text-white text-2xl py-4" data-id="element-255">No lo estaban.</p>

            <p data-id="element-256">
              Porque nadie se sentó con ellos. Nadie explicó la letra pequeña.
              Nadie explicó qué significa realmente "cobertura completa". Nadie
              les habló sobre la diferencia entre lo que creen que está cubierto
              y lo que la póliza realmente paga.
            </p>

            <p data-id="element-257">
              Entonces cuando pasa lo peor — y sí pasa — lo descubren de la
              manera más difícil.
            </p>

            <p data-id="element-258">
              Presentan un reclamo. Y se lo niegan. O reciben una fracción de lo
              que esperaban.
            </p>

            <p className="italic text-gray-400" data-id="element-259">
              ¿Y el agente que les vendió la póliza? Desaparecido. Siguió
              adelante. A la próxima venta.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}